import { NotSupportedException } from '../../Exceptions';
import trimStart from '../../Strings/trimStart';
import parseQSIValue from "./parseQSIValue";
/**
 * Deserializes a query string into an array of {@link QueryStringItem}'s
 * @param queryString The query string to deserialize
 * @returns {QueryStringItem[]} A collections of the items in the query string.
 */
export default function deserializeQS(queryString) {
    if (queryString.length === 0) {
        return [];
    }
    queryString = trimStart(queryString, '?');
    const segments = queryString.split("&");
    return segments
        .map(deserializeQSParameter);
}
function deserializeQSParameter(segment /*, index: number, array: string[]*/) {
    const components = segment.match(/([^=]+)(?:=(.*))/i);
    if ((components === null || components === void 0 ? void 0 : components.length) === 3) {
        return {
            name: components[1],
            value: parseQSIValue(decodeURIComponent(components[2]))
        };
    }
    else {
        throw new NotSupportedException(`Segment '${segment}' is an unsupported query string parameter.`);
    }
}
